var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ToggleGroup',{attrs:{"controls":_vm.controls,"toggles":_vm.properties,"title":_vm.$t('common.keywords.properties')},on:{"update:toggles":function($event){_vm.properties=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }